<template>
  <div class="main-page initial">
    <Menus title="终端机设置">
      <a href="javascript:void(0)">
        <div class="">
        </div>
        <span></span>
      </a>
      <router-link
        to="/"
        v-if="geography"
      >
        <div class="img_block">
          <img
            class="img_margin"
            src="static/img/icon_fanhuishouye.png"
            alt="返回首页"
          >
        </div>
        <span>返回首页</span>
      </router-link>
    </Menus>
    <div class="container-flex">
      <Dialogs v-model="dialog">
        <div class="body">
          <form class="form-horizontal">
            <div class="form-group login-row">
              <label
                for="inputEmail3"
                class="col-sm-2 control-label input-label"
              >账号</label>
              <div class="col-sm-10">
                <input
                  type="email"
                  class="form-control login-input"
                  id="inputEmail3"
                  placeholder="用户名"
                >
              </div>
            </div>
            <div class="form-group login-row">
              <label
                for="inputPassword3"
                class="col-sm-2 control-label input-label"
              >密码</label>
              <div class="col-sm-10">
                <input
                  type="password"
                  class="form-control login-input"
                  id="inputPassword3"
                  placeholder="Password"
                >
              </div>
            </div>
          </form>
        </div>
        <template slot="foot">
          <a class="lp-btn large primary login-btns">登录</a>
          <a
            class="lp-btn large default"
            @click="dialog.show=false"
          >取消</a>
        </template>
      </Dialogs>
      <div class="initial-setting">

        <!-- <h3 class="initial-setting__title">终端机设置</h3> -->
        <div class="initial-setting__content">
          <ul>
            <li class="steps step1">
              <p class="step_title">第一步</p>
              <img
                :src="url"
                alt=""
                v-if="url"
                style="width:2rem"
              >
              <p class="tips">请用微信扫描上面二维码，填写设备信息，提交保存后点击右边按钮。</p>

            </li>
            <li class="steps">
              <p class="step_title">第二步</p>
              <div class="btn_reload">
                <a href="/">完成设置</a>
              </div>
              <p class="tips">微信设置完成后，请点击按钮开始使用。</p>

            </li>
          </ul>

        </div>

        <div class="tech-support">

          <!-- <p>
            <span @click="clearAllCache">技术支持</span>：
            <span @click="showService">律品汇科技（北京）有限公司</span>
          </p>
          <p>云南省司法厅 <a class="setting-btn">
            </a>
          </p> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Menus from '@/components/Menu.vue'
import Dialogs from '@/components/Dialog.vue'
export default {
  data () {
    return {
      url: '',
      modalShow: false,
      dialog: {
        show: false,
        title: '管理登录',
        cancelBtn: '返回'
      },
      geography: ''
    }
  },
  components: {
    Menus,
    Dialogs
  },
  async mounted () {
    const point = this.$store.state.device.point
    this.geography = point.geography
    console.log('地理坐标', this.geography)
    let uuid = localStorage.code || point.no
    console.log('sss', uuid)
    let res = await this.$get('https://yn.12348.laway.cn/pufa/api/create/qrcode/?qr_url=https://yn.12348.laway.cn/wechat/login/redirect/machine/?uuid=' + uuid)
    this.url = res.result.url
  },
  methods: {
    openModal () {
      this.dialog.show = !this.dialog.show
    },
    reload () {
      window.location.reload()
      console.log('reload')
    },
    clearAllCache () {
      if (NativeInterface && NativeInterface.clearAllCache) { // eslint-disable-line
        NativeInterface.clearAllCache() // eslint-disable-line
      }
    },
    showService () {
      if (NativeInterface && NativeInterface.showService) { // eslint-disable-line
        NativeInterface.showService() // eslint-disable-line
      }
    }
  }
}
</script>
<style lang="stylus">
.initial
  // position relative
.initial-setting
  padding-top 110px
  height 100vh
  position relative
  // z-index 1000
  .initial-setting__title
    text-align center
    font-size 0.48rem
    color #fff
  .initial-setting__content
    padding 1rem 1rem 0
    ul
      display flex
      width 100%
      flex-direction row
      flex-wrap wrap
      list-style none
      padding 0
    .step_title
      font-size 0.36rem
      color #fff
    .steps
      width 45%
      border 0.01rem solid rgba(255, 255, 255, 0.3)
      padding 0.5rem 0.2rem
      margin-bottom 0
      text-align center
      color #fff
      border-radius 15px
      background rgba(255, 255, 255, 0.1)
    .step1
      margin-right 10%
    .step1 img
      margin 0 auto
    .steps p
      padding-bottom 0.2rem
    .steps a
      width 3rem
      height 0.8rem
      background-color #2ecc71
      border-radius 0.08rem
      display block
      margin 0 auto
      color #fff
      text-align center
      line-height 0.8rem
      font-size 0.22rem
    .tips
      font-size 0.24rem
      padding 0.2rem 0.5rem 0
    .btn_reload
      padding-top 0.2rem
      border-radius 0.1rem
    .btn-suggest
      display none !important
  .tech-support
    color #fff
    text-align center
    font-size 0.26rem
    margin-top 0.8rem
    a
      color #ffffff
      margin-left 0.4rem
    .setting-btn
      width 0.4rem
      height 0.2rem
      font-size 0.26rem
.login-input
  font-size 0.26rem
  line-height 1
  height 0.8rem
.input-label
  font-size 0.3rem
  line-height 0.8rem
.login-btns
  color #fff !important
.login-row
  margin-bottom 0.2rem
.back-bg
  background none
</style>
